<script>
import ProofViewFileThumbnail from "./proof-view-file-thumbnail";

export default {
  name: "proof-view-sidebar-left",
  components: {ProofViewFileThumbnail},
  props: ["files", "shouldHideFilesToReviewScreen", "activeFile", "isCompareMode", "isMobile", "disabled", "changeTrackingSummary"],
  data() {
    return {
      open: false
    };
  },
  mounted() {
    this.$emit('width-changed', this.$el.offsetWidth);
    this.setActiveFile(this.activeFile);
  },
  methods: {
    setActiveFile(file) {
      if (this.disabled) return;
      this.curFile = file;
      this.$emit('set-active-file', file);
    },
    onClickViewAllFiles() {
      if (this.disabled) return;
      this.$emit('show-files-to-review-screen');
    },
    setOpen() {
      // debugger
      if (this.disabled) return;
      this.open = true;
    },
    setClose() {
      // debugger
      if (this.disabled) return;
      this.open = false;
    }
  },
  computed: {
    activeFileID() {
      return _.get(this.activeFile, 'id', 0);
    },
    showHorizontal() {
      return this.isCompareMode || this.isMobile;
    }
  }
}
</script>

<template>
  <div @mouseleave="!showHorizontal && setClose()" @mouseover="!showHorizontal && setOpen()" id="review-available-files"
       :class="{'file-sidebar' : !disabled && !showHorizontal, 'horizontal d-flex flex-row align-items-center' : isCompareMode, 'd-flex flex-row w-100 align-items-center' : isMobile, 'flex-column d-none position-absolute' : !showHorizontal}"
       class="py-3 px-2 bg-ashore-white border-end border-gray-100 d-lg-flex h-100 start-0 top-0 overflow-auto">
    <proof-view-file-thumbnail v-for="f in files"
                               :key="f.id"
                               :file="f"
                               :active-file-id="activeFileID"
                               :show-title="open && !isCompareMode"
                               :show-horizontal="showHorizontal"
                               :is-mobile="isMobile"
                               :disabled="disabled"
                               :change-tracking-summary="changeTrackingSummary"
                               @selected="setActiveFile"
    />
    <button v-if="(open && !this.$props.shouldHideFilesToReviewScreen && this.files.length > 1)" class="btn border w-100 fs-14 text-gray-700 border-gray-300 view-all-files" :class="showHorizontal ? 'view-file-btn' : 'mt-3'" @click="onClickViewAllFiles">
      View All Files
    </button>
  </div>
</template>

<style scoped>
.horizontal {
  width: 100%;
  height: fit-content !important;
}
.file-sidebar{
  z-index: 1100;
  transition: all ease-in-out 300ms;
  width: 73px;
}
.file-sidebar:hover{
  width: 400px;
}
.view-file-btn {
  white-space: nowrap;
  width: max-content !important;
  height: min-content;
}
.view-all-files {
  font-weight: 400;
}
</style>
